import React from 'react';
import { NotificationContext, useNotificationContext } from './NotificationContext';
let showNotification;
export const NotificationProvider = _ref => {
  let {
    children,
    buttonType
  } = _ref;
  const [notification, setNotification] = React.useState({});
  showNotification = newNotification => {
    const action = newNotification.action ? {
      type: buttonType,
      ...newNotification.action
    } : undefined;
    setNotification({
      ...newNotification,
      action,
      show: true
    });
  };
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: {
      ...notification
    }
  }, children);
};
export const useNotification = () => {
  const {
    show
  } = useNotificationContext();
  return {
    show,
    showNotification
  };
};
//# sourceMappingURL=NotificationProvider.js.map